module.exports = __webpack_public_path__ + "img/small-ship-wreck-g.cb85176e.png";